import React from 'react';
import styles from './HomeLocationBodyText.module.css';

interface Props {
  text: string;
}

const HomeLocationBodyText: React.FC<Props> = ({ text }: Props) => {
  return <p className={styles.text}>{text}</p>;
};

export default HomeLocationBodyText;
